export default __webpack_public_path__ + "static/media/raridades2.60161476.png";